<template>
    <div class="content-wrap sun analysis">
        <Back :backFunc="() => this.$emit('showUserRes', true)"/>
        <div class="analysis-content">
            <div ref="content">
                <QueItem
                    :question="results[index].quiz"
                    :disabled="true"
                    :val="_results[index]">
                    <span slot="queIndex">
                        {{index + 1}}/{{results.length}}
                    </span>
                    <template slot="icon" slot-scope="{data}" v-if="data.checked">
                        <i v-if="results[index].quiz.option_type === 'single' " :class="data.checked && results[index].is_right ?'icon icon-tick-v2' : 'icon icon-cross-v2' " />
                        <i v-else :class="results[index].quiz.multi_right_seq_num.indexOf(data.seq_id) >= 0 ?'icon icon-tick-v2' : 'icon icon-cross-v2' " />
                    </template>
                </QueItem>
                <p class="analysis-res">正确答案：
                    <span v-if="results[index].quiz.option_type === 'single'">{{['A', 'B', 'C', 'D'][results[index].quiz.right_seq_num - 1]}}</span>
                    <span v-else>{{ results[index].quiz.multi_right_seq_num.map(item => ['A', 'B', 'C', 'D'][item - 1]).join(',') }}</span>

                </p>
                <p>解析: {{results[index].quiz.analysis}}</p>
                <my-image
                    v-if="results[index].quiz.image_analysis"
                    class="analysis-image"
                    :src="results[index].quiz.image_analysis"
                    @click="(e) => previewImg(e, results[index].quiz.image_analysis)"
                />
            </div>
        </div>
        <div class="content-bottom-wrap">
            <Button
                class="btn btn-primary"
                :disabled="!index"
                @click="() => {index--}"
            >上一题</Button>
            <Button
                class="btn btn-primary"
                v-if="index < results.length - 1"
                @click="() => {index++}"
            >下一题</Button>
            <Button
                class="btn btn-primary"
                v-if="index == results.length - 1"
                @click="() => this.$emit('showUserRes', true)"
            >查看结果</Button>
        </div>
    </div>
</template>

<script>
import { Button } from 'vant';
import { arrRenameKey } from '@/utils/func';
import QueItem from '@/components/Question';
import Back from '@/components/Back';

export default {
    name: 'ques',
    props: ['results'],
    components: {
        QueItem,
        Button,
        Back
    },
    watch: {
        index() {
            this.$refs.content.scrollTop = 0
        }
    },
    computed: {
        _results() {
            const [ ...res ] = this.results;
            return arrRenameKey(res, {answer_seq_num: 'seq_id'})
        }
    },
    data() {
        return {
            index: 0,
        };
    },
    mounted() {
    },
    methods: {
        previewImg(e, url) {
            this.$hevueImgPreview(url);
            e.stopPropagation();
        },
    }
};
</script>
<style lang="less" scoped>
.analysis {
    .que-image {
        display: block;
        margin: auto;
        max-width: 100%;
        max-height: 30vh;
    }
    .btn {
        &:first-child{
            margin-right: 14vw;
        }
    }
    p{
        margin: 0;
        font-size: 14px;;
        margin-top: 2rem;
        color: #082754;
    }
    .analysis-res {
        margin-top: 4rem;
    }
    .analysis-content {
        position: relative;
        margin: 15vh auto 0;
        height: 1;
        background: #fff;
        flex: 1;
        padding: 2rem 1rem;
        width: calc(76vw - 2rem);
        >div {
            padding: 0 1rem;
            width: calc(100% - 2rem);
            height: 100%;
            overflow: scroll;
        }
        /deep/.icon {
            margin-top: .3rem;
            margin-right: .7rem;
            font-size: 1.5rem;
            display: block;
            &.icon-cross-v2 {
            background-color: #f64c4c;
            }
            &.icon-tick-v2 {
                background-color: #41e54c;
            }
        }
    }
    
    .analysis-image {
        display: block;
        margin: 10px auto auto;
        max-width: 100%;
        max-height: 30vh;
    }

    .content-bottom-wrap {
        flex: inherit;
        margin: 3rem auto;
    }
}
</style>
